import { Component, Host, h, Prop, Element } from '@stencil/core'

@Component({
  tag: 'bam-video-wrapper',
})
export class BamVideoWrapper {
  @Element() host: HTMLElement[];
  @Prop() headline?: string;
  @Prop() size: 'small' | 'large';

  private margintopClass: string;

  componentWillLoad() {
    this.margintopClass = !this.headline ? "mt-small block" : "";
  }

  render() {
    return (
      <Host class={this.margintopClass}>
        {this.headline !== "" &&
          <div class={this.size === 'small' ? 'mt-x-small mb-normal' : 'mb-x-large'}>
            <bal-heading level={this.size === 'small' ? 'h3' : 'h2' } space="none">{this.headline}</bal-heading>
          </div>
        }
        <slot name="video"></slot>
      </Host>
    )
  }
}
